module.exports = __webpack_public_path__ + "static/img/6111_phase_function_Paper_PointsHejduk_Prediction.700d352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6111_phase_function_Paper_PointsHejduk_Prediction.png
// module id = SxUn
// module chunks = 0